import { AxiosResponse } from 'axios';
import { CANCELLED_REQUEST_MESSAGE, CANCELLED_REQUEST_STATUS } from '../utils';

export default class APIStandardResponse<T> {
  isSuccess: boolean;
  statusCode: number;
  data: T | null;
  message: string | null;
  errorMessages: string[] | null;

  constructor(
    isSuccess: boolean,
    statusCode: number,
    data: T | null,
    message: string | null,
    errorMessages: string[] | null,
  ) {
    this.isSuccess = isSuccess;
    this.statusCode = statusCode;
    this.data = data;
    this.message = message;
    this.errorMessages = errorMessages;
  }
}

export const apiStandardResponse = <T>(res?: AxiosResponse): APIStandardResponse<T> => {
  if (res) {
    const data = res.data.data ?? res.data;
    return new APIStandardResponse<T>(
      res.data.isSuccess,
      res.status,
      data,
      res.data.message,
      res.data.errorMessages,
    );
  }
  return new APIStandardResponse<T>(
    false,
    CANCELLED_REQUEST_STATUS,
    null,
    CANCELLED_REQUEST_MESSAGE,
    [CANCELLED_REQUEST_MESSAGE],
  );
};
